__turbopack_context__.v({
  "background": "PageBackground-module-scss-module__m1W9iq__background",
  "embed": "PageBackground-module-scss-module__m1W9iq__embed",
  "image": "PageBackground-module-scss-module__m1W9iq__image",
  "imageDesktop": "PageBackground-module-scss-module__m1W9iq__imageDesktop",
  "imageMobile": "PageBackground-module-scss-module__m1W9iq__imageMobile",
  "imageWrapper": "PageBackground-module-scss-module__m1W9iq__imageWrapper",
  "stack-module-0": "PageBackground-module-scss-module__m1W9iq__stack-module-0",
  "stack-module-1": "PageBackground-module-scss-module__m1W9iq__stack-module-1",
  "stack-module-10": "PageBackground-module-scss-module__m1W9iq__stack-module-10",
  "stack-module-11": "PageBackground-module-scss-module__m1W9iq__stack-module-11",
  "stack-module-12": "PageBackground-module-scss-module__m1W9iq__stack-module-12",
  "stack-module-13": "PageBackground-module-scss-module__m1W9iq__stack-module-13",
  "stack-module-14": "PageBackground-module-scss-module__m1W9iq__stack-module-14",
  "stack-module-15": "PageBackground-module-scss-module__m1W9iq__stack-module-15",
  "stack-module-16": "PageBackground-module-scss-module__m1W9iq__stack-module-16",
  "stack-module-17": "PageBackground-module-scss-module__m1W9iq__stack-module-17",
  "stack-module-18": "PageBackground-module-scss-module__m1W9iq__stack-module-18",
  "stack-module-19": "PageBackground-module-scss-module__m1W9iq__stack-module-19",
  "stack-module-2": "PageBackground-module-scss-module__m1W9iq__stack-module-2",
  "stack-module-20": "PageBackground-module-scss-module__m1W9iq__stack-module-20",
  "stack-module-3": "PageBackground-module-scss-module__m1W9iq__stack-module-3",
  "stack-module-4": "PageBackground-module-scss-module__m1W9iq__stack-module-4",
  "stack-module-5": "PageBackground-module-scss-module__m1W9iq__stack-module-5",
  "stack-module-6": "PageBackground-module-scss-module__m1W9iq__stack-module-6",
  "stack-module-7": "PageBackground-module-scss-module__m1W9iq__stack-module-7",
  "stack-module-8": "PageBackground-module-scss-module__m1W9iq__stack-module-8",
  "stack-module-9": "PageBackground-module-scss-module__m1W9iq__stack-module-9",
  "video": "PageBackground-module-scss-module__m1W9iq__video",
  "z-base": "PageBackground-module-scss-module__m1W9iq__z-base",
  "z-content": "PageBackground-module-scss-module__m1W9iq__z-content",
  "z-footer": "PageBackground-module-scss-module__m1W9iq__z-footer",
  "z-header": "PageBackground-module-scss-module__m1W9iq__z-header",
  "z-hero": "PageBackground-module-scss-module__m1W9iq__z-hero",
  "z-logo": "PageBackground-module-scss-module__m1W9iq__z-logo",
  "z-logo-effect": "PageBackground-module-scss-module__m1W9iq__z-logo-effect",
  "z-navigation": "PageBackground-module-scss-module__m1W9iq__z-navigation",
  "z-sub": "PageBackground-module-scss-module__m1W9iq__z-sub",
});
